import { render, staticRenderFns } from "./highlighted-vehicle-features.vue?vue&type=template&id=6f00588b&"
import script from "./highlighted-vehicle-features.vue?vue&type=script&lang=js&"
export * from "./highlighted-vehicle-features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports